import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/StyleDashboard.js";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ChartOptions from "../../utils/ChartOptions";
import exporting from "highcharts/modules/exporting";
exporting(Highcharts);

ChartOptions(Highcharts);

const processData = (data, startDate, endDate) => {
  let out = [];
  let currentDate = new Date(startDate);
  data.forEach((element) => {
    let newElement = [];
    newElement[0] = currentDate.getTime();
    newElement[1] = element;
    out.push(newElement);
    currentDate.setDate(currentDate.getDate() + 1);
  });
  return out;
};

export default function MovementChart({ data, startDate, endDate }) {
  const style = Style();
  const [dataChart, setDataChart] = React.useState([]);
  useEffect(() => {
    setDataChart(processData(data, startDate, endDate));
  }, [data]);

  const timezone = new Date().getTimezoneOffset();

  return (
    <Paper className={style.movementChart}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: "line",
          },
          title: {
            text: "Movimientos",
          },
          xAxis: {
            type: "datetime",
          },
          yAxis: {
            title: {
              text: "Cantidad",
            },
            min: 0,
          },
          time: {
            useUTC: false,
          },
          plotOptions: {
            line: {
              dataLabels: {
                enabled: false,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 1);
                },
              },
              events: {
                checkboxClick: function (event) {
                  if (event.checked) {
                    var enabled = !this.options.dataLabels.enabled;
                    this.update({
                      dataLabels: {
                        enabled: true,
                      },
                    });

                    return true;
                  } else {
                    var a = !this.options.dataLabels.enabled;
                    this.update({
                      dataLabels: {
                        enabled: false,
                      },
                    });

                    return false;
                  }
                },
              },
              enableMouseTracking: true,
              showInLegend: true,
              showCheckbox: true,
            },
          },

          exporting: {
            enabled: false,
          },
          tooltip: {
            pointFormatter: function () {
              return `${this.series.name} : ${Highcharts.numberFormat(
                this.y,
                2
              )}`;
            },
          },
          series: [
            {
              name: "Movimientos de usuarios activos",
              data: dataChart,
            },
          ],
        }}
      />
    </Paper>
  );
}
